import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import DayTime from '../../../common/DayTimeWrapper'
import { CBCTypeId, defaultPageSize, EMPTY_DATA, EXCHNAGERATE, RMDOMESTIC, RMIMPORT, ZBCTypeId, SIMULATION_MAX_DIGITS_AFTER_DECIMAL, PAINTTECHNOLOGY } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { runVerifySimulation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import DatePicker from "react-datepicker";
import { useForm, Controller } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import VerifySimulation from '../VerifySimulation';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import _, { debounce } from 'lodash'
import { VBC, ZBC } from '../../../../config/constants';
import { PaginationWrapper } from '../../../common/commonPagination';
import WarningMessage from '../../../common/WarningMessage';
import { getMaxDate } from '../../SimulationUtils';
import PopupMsgWrapper from '../../../common/PopupMsgWrapper';
import { APPLICABILITY_RM_SIMULATION, FORGING, RM_IMPACT_DOWNLOAD_EXCEl, RM_IMPACT_DOWNLOAD_EXCEl_IMPORT } from '../../../../config/masterData';
import ReactExport from 'react-export-excel';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import LoaderCustom from '../../../common/LoaderCustom';
import { simulationContext } from '..';
import { useLabels } from '../../../../helper/core';
import AddOtherCostDrawer from '../../../masters/material-master/AddOtherCostDrawer';
import AddConditionCosting from '../../../costing/components/CostingHeadCosts/AdditionalOtherCost/AddConditionCosting';
import { parsedDate, updateCostValue } from '../../../common/CommonFunctions';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter } from '../../../../helper/simulationValidation';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';
import { useSimulationGrid, useSimulationUndo, useSimulationVBC, useSimulationConfig, useSimulationCalculations } from '../../../../hooks/simulation';
import UndoButton from '../common/UndoButton';
import RedoButton from '../common/RedoButton';

const gridOptions = {

};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function RMSimulation(props) {
    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};

    const { list, isbulkUpload, rowCount, isImpactedMaster, costingAndPartNo, tokenForMultiSimulation, technologyId } = props

    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [textFilterSearch, setTextFilterSearch] = useState('')
    const [isDisable, setIsDisable] = useState(false)
    const [effectiveDate, setEffectiveDate] = useState('');
    const [maxDate, setMaxDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false)
    const [titleObj, setTitleObj] = useState({})
    const [showPopup, setShowPopup] = useState(false)
    const [popupMessage, setPopupMessage] = useState('There is no changes in scrap rate Do you want to continue')
    const gridRef = useRef();
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [scrapRateviewTooltip, setScrapRateViewTooltip] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [isScrapUOMApplyTemp, setIsScrapUOMApplyTemp] = useState(false)
    const [openOtherCostDrawer, setOpenOtherCostDrawer] = useState(false)
    const [openConditionCostDrawer, setOpenConditionCostDrawer] = useState(false)
    const [otherCostDetailForRow, setOtherCostDetailForRow] = useState([])

    const [conditionCostDetailForRow, setConditionCostDetailForRow] = useState([])
    const [isViewFlag, setIsViewFlag] = useState(false)
    const [rowData, setRowData] = useState([])
    const [basicRate, setBasicRate] = useState('')
    const [netCostWithoutConditionCost, setNetCostWithoutConditionCost] = useState('')

    // FIX Bug #1: Removed rowIndex state - replaced with editRowId for ID-based operations
    const [editRowId, setEditRowId] = useState('') // CRITICAL: Store row ID instead of index for filter/sort safety
    const { register, control, setValue, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const { technologyLabel, vendorLabel } = useLabels();
    const dispatch = useDispatch()

    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const { selectedMasterForSimulation, selectedTechnologyForSimulation, exchangeRateListBeforeDraft } = useSelector(state => state.simulation)
    const simulationApplicability = useSelector(state => state.simulation.simulationApplicability)

    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)
    const { filteredRMData } = useSelector(state => state.material)

    // ========================================================================
    // COMMON HOOKS - Using centralized simulation hooks
    // ========================================================================

    // CRITICAL: Define getRowId function ONCE and use it in both hooks
    const getRowId = useCallback((row) => row.CostingId || row.RawMaterialId, []);

    // Grid operations hook - handles gridApi, pagination, node finding
    const {
        gridApi,
        onGridReady: commonOnGridReady,
        findNodeByRowId
    } = useSimulationGrid({
        defaultPageSize,
        getRowId  // Pass the same getRowId to grid hook
    });

    // Undo/Redo hook - handles undo/redo functionality with keyboard shortcuts
    const {
        saveUndoState,
        handleUndo,
        handleRedo,
        undoCount,
        redoCount,
        canUndo,
        canRedo
    } = useSimulationUndo({
        gridApi,
        findNodeByRowId,
        disabled: isImpactedMaster,
        getRowId,  // Use the same getRowId function
        enableKeyboardShortcuts: true,
        updateListData: useCallback((rowId, restoredData) => {
            const index = list.findIndex(item => getRowId(item) === rowId);
            if (index !== -1) {
                list[index] = { ...restoredData };
            }
        }, [list, getRowId])
    });

    // VBC hook - handles VBC/ZBC/CBC costing type detection
    const {
        isZBCRow, // eslint-disable-line no-unused-vars
        isVBCRow, // eslint-disable-line no-unused-vars
        isCBCRow, // eslint-disable-line no-unused-vars
        getRowCostingType, // eslint-disable-line no-unused-vars
        isRowVBC, // eslint-disable-line no-unused-vars
        shouldShowConditionCostColumn // eslint-disable-line no-unused-vars
    } = useSimulationVBC({
        list,
        ZBCTypeId: ZBCTypeId,
        VBCTypeId: list?.[0]?.CostingHead === 'Vendor Based' ? list?.[0]?.CostingTypeId : null,
        CBCTypeId: CBCTypeId
    });

    // Config hook - handles configuration and decimal formatting
    const {
        decimalPlaces, // eslint-disable-line no-unused-vars
        formatNumber, // eslint-disable-line no-unused-vars
        isVisible, // eslint-disable-line no-unused-vars
        config // eslint-disable-line no-unused-vars
    } = useSimulationConfig('NoOfDecimalForPrice');

    // Calculations hook - common calculation helpers
    const {
        checkNull, // eslint-disable-line no-unused-vars
        calculateNetLandedCost, // eslint-disable-line no-unused-vars
        calculateBasicPrice, // eslint-disable-line no-unused-vars
        calculatePercentageChange, // eslint-disable-line no-unused-vars
        applyPercentageToBase // eslint-disable-line no-unused-vars
    } = useSimulationCalculations();

    const columnWidths = {
        // Base column widths - used for compressed/expanded views
        COMPRESSED_WIDTH: 50,
        STANDARD_WIDTH: {
            SMALL: 80,
            MEDIUM: 120,
            LARGE: 160,
            EXTRA_LARGE: 190
        },

        // Main Information Columns
        CostingHead: showCompressedColumns ? 50 : 140,
        VendorCode: showCompressedColumns ? 50 : 160,
        RawMaterialName: showCompressedColumns ? 50 : 160,
        RawMaterialGradeName: showCompressedColumns ? 50 : 120,
        RawMaterialSpecificationName: showCompressedColumns ? 50 : 140,
        RawMaterialCode: showCompressedColumns ? 50 : 135,
        Category: showCompressedColumns ? 50 : 110,
        TechnologyName: showCompressedColumns ? 50 : 125,
        CustomerName: showCompressedColumns ? 50 : 160,
        PlantCode: showCompressedColumns ? 50 : 160,
        UnitOfMeasurementName: showCompressedColumns ? 50 : 100,
        CostingNumber: showCompressedColumns ? 50 : 190,
        PartNumber: showCompressedColumns ? 50 : 190,
        RMFreightCost: showCompressedColumns ? 50 : 150,
        RMShearingCost: showCompressedColumns ? 50 : 170,
        MachiningScrapRate: showCompressedColumns ? 50 : 170,
        EffectiveDate: showCompressedColumns ? 50 : 140,

        // Cost Columns with Existing/Revised structure
        BasicRate: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },
        ScrapRate: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },
        OtherCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 200
        },
        BasicPrice: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        ConditionCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        NetCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        PlantCurrency: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },
        Percentage: {
            field: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 60 : 100
        },

        // Additional metadata fields
        EntryType: showCompressedColumns ? 50 : 120,
        ScrapUnitOfMeasurement: showCompressedColumns ? 50 : 150,
        ExchangeRate: showCompressedColumns ? 50 : 140,
        ExchangeRateSourceName: showCompressedColumns ? 50 : 120,
        Currency: showCompressedColumns ? 50 : 180,
        LocalCurrency: showCompressedColumns ? 50 : 120,

        // Legacy support for existing columnWidths usage
        OldRMNetLandedCostConversion: showCompressedColumns ? 70 : 120,
        NewRMNetLandedCostConversion: showCompressedColumns ? 70 : 120,
        ScrapRatePerScrapUOM: showCompressedColumns ? 70 : 120,
        NewScrapRatePerScrapUOM: showCompressedColumns ? 70 : 120,
        NewNetCostWithoutConditionCost: showCompressedColumns ? 70 : 120,
        NetCostWithoutConditionCost: showCompressedColumns ? 70 : 120,
        NetLandedCost: showCompressedColumns ? 70 : 120,
        NewNetLandedCost: showCompressedColumns ? 70 : 120
    };

    const onGridReady = (params) => {
        // Use common hook's onGridReady for pagination restoration
        commonOnGridReady(params);
        // Note: Tooltip initialization moved to useEffect with proper cleanup
    };

    // Separate useEffect to handle bulk upload count updates when isbulkUpload changes
    useEffect(() => {
        if (isbulkUpload && rowCount) {
            setValue('NoOfCorrectRow', rowCount.correctRow)
            setValue('NoOfRowsWithoutChange', rowCount.NoOfRowsWithoutChange)
            setTitleObj(prevState => ({ ...prevState, rowWithChanges: rowCount.correctRow, rowWithoutChanges: rowCount.NoOfRowsWithoutChange }))
        }
    }, [isbulkUpload, rowCount])

    useEffect(() => {
        setIsLoader(true)
        let scrapUOMApplyList = _.map(list, 'IsScrapUOMApply')
        const timer = setTimeout(() => {
            if (scrapUOMApplyList?.includes("Yes") || scrapUOMApplyList?.includes(true)) {
                setIsScrapUOMApplyTemp(true)
                setIsLoader(false)
            } else {
                setIsScrapUOMApplyTemp(false)
                setIsLoader(false)
            }
        }, 200);
        if (!isImpactedMaster && !isbulkUpload) {
            list && list?.forEach(item => {
                // Only set default values if they don't already exist (to preserve bulk upload data)
                if (item.NewBasicRate === undefined || item.NewBasicRate === null) {
                    item.NewBasicRate = item.BasicRatePerUOM
                }
                if (item.NewScrapRatePerScrapUOM === undefined || item.NewScrapRatePerScrapUOM === null) {
                    item.NewScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                }
                if (item.NewOtherNetCost === undefined || item.NewOtherNetCost === null) {
                    item.NewOtherNetCost = item.OtherNetCost
                }
                if (item.NewNetConditionCost === undefined || item.NewNetConditionCost === null) {
                    item.NewNetConditionCost = item.NetConditionCost  // ADD KEY FROM API
                }
                if (item.NewNetCostWithoutConditionCost === undefined || item.NewNetCostWithoutConditionCost === null) {
                    item.NewNetCostWithoutConditionCost = item.NetCostWithoutConditionCost
                }
                if (!item.NewRawMaterialOtherCostDetails) {
                    item.NewRawMaterialOtherCostDetails = item.RawMaterialOtherCostDetails || []; // Set to existing data or empty array
                }
                if (!item.NewRawMaterialConditionCostDetails) {
                    item.NewRawMaterialConditionCostDetails = item.RawMaterialConditionsDetails || []; // Set to existing data or empty array
                }
                setNetCostWithoutConditionCost(item.NewNetCostWithoutConditionCost)
            })
        }

        // Cleanup function to prevent memory leak
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // FIX Bug #1: Use editRowId instead of rowIndex for ID-based operations
        if (list && editRowId && !isImpactedMaster) {
            // Find the correct row using the ID (not visual index)
            const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === editRowId);

            if (rowIndexInList === -1) return; // Row not found

            let obj = list[rowIndexInList];
            obj.otherCostTableData = obj.NewRawMaterialOtherCostDetails
            obj.conditionTableData = obj.NewRawMaterialConditionCostDetails
            const updatedObjOtherCost = updateCostValue(false, obj, basicRate, true)
            obj.NewRawMaterialOtherCostDetails = updatedObjOtherCost?.tableData

            obj.NewOtherNetCost = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostConversion = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostLocalConversion = updatedObjOtherCost?.formValue?.value


            const basicPrice = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value))

            const updatedObjConditionCost = updateCostValue(true, obj, basicPrice, true)
            obj.NewRawMaterialConditionCostDetails = updatedObjConditionCost?.tableData


            obj.NewNetConditionCost = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostConversion = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostLocalConversion = updatedObjConditionCost?.formValue?.value


            obj.NewNetLandedCost = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))
            obj.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value))
            obj.NewNetLandedCostConversion = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))
            obj.NewNetLandedCostLocalConversion = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))

            setNetCostWithoutConditionCost(obj.NewNetCostWithoutConditionCost)
            // FIX Bug #1: Update using the found index
            list[rowIndexInList] = obj

            // FIX Bug #6: Remove artificial 200ms delay - loader not needed for instant operations
            setIsLoader(false);
        }
    }, [basicRate, openOtherCostDrawer, openConditionCostDrawer, otherCostDetailForRow, list, editRowId, isImpactedMaster])

    useEffect(() => {

        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
    }, [showverifyPage, handleEditMasterPage, showEditMaster])
    useEffect(() => {
        if (list && list.length > 0) {
            window.screen.width >= 1921 && gridRef?.current?.api?.sizeColumnsToFit();
            let tempList = [...list]
            if (simulationApplicability?.value === APPLICABILITY_RM_SIMULATION) {
                tempList = [...exchangeRateListBeforeDraft]
            }
            let maxDate = getMaxDate(tempList)
            setMaxDate(parsedDate(maxDate?.EffectiveDate));
        }
    }, [list, simulationApplicability?.value, exchangeRateListBeforeDraft])

    // Tooltip initialization with proper DOM element checking and cleanup
    useEffect(() => {
        // Only enable tooltips if not impacted master and grid is ready
        if (!isImpactedMaster && gridApi) {
            let timer = null;
            let attemptCount = 0;
            const maxAttempts = 10; // Maximum 10 attempts (1 second total)

            const checkAndEnableTooltips = () => {
                const basicRateTooltip = document.getElementById('basicRate-tooltip');
                const scrapRateTooltip = document.getElementById('scrapRate-tooltip');

                if (basicRateTooltip && scrapRateTooltip) {
                    // Both elements exist, enable tooltips
                    setShowTooltip(true);
                } else if (attemptCount < maxAttempts) {
                    // Elements don't exist yet, try again
                    attemptCount++;
                    timer = setTimeout(checkAndEnableTooltips, 100);
                }
            };

            // Start checking after a small delay to let grid render
            timer = setTimeout(checkAndEnableTooltips, 100);

            // Cleanup function to prevent memory leak
            return () => {
                if (timer) {
                    clearTimeout(timer);
                }
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImpactedMaster, gridApi]); // Run when grid becomes ready or impacted master changes

    const setValueFunction = (check, tempList = []) => {
        // Prepare simulation data and dispatch POST request to verify simulation
        const filteredMasterId = masterList?.find(item => item?.Text === "RM Import")?.Value;
        let obj = {
            IsExchangeRateSimulation: check,
            SimulationRawMaterials: [],
            SimulationExchangeRates: [],
            SimulationIds: [],
            TechnologyId: technologyId ? technologyId : list?.[0]?.TechnologyId,
            SimulationTechnologyId: check ? EXCHNAGERATE : selectedMasterForSimulation?.value,
            //EffectiveDate: DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
            LoggedInUserId: loggedInUserId(),
            SimulationHeadId: list[0]?.CostingTypeId,
            IsSimulationWithOutCosting: false,
            ExchangeRateSimulationTechnologyId: filteredMasterId
        };

        if (filteredRMData?.plantId && filteredRMData?.plantId?.value) {
            obj.PlantId = filteredRMData?.plantId ? filteredRMData?.plantId?.value : ''
        }
        let tempArr = []
        if (String(selectedMasterForSimulation?.value) === String(RMDOMESTIC) || String(selectedMasterForSimulation?.value) === String(RMIMPORT) || String(selectedMasterForSimulation?.value) === String(EXCHNAGERATE)) {
            list && list.map(item => {
                // Check if any cost field has been changed
                const hasBasicRateChange = item.NewBasicRate !== undefined || item.NewBasicrateFromPercentage;
                const hasScrapRateChange = item.NewScrapRate !== undefined;
                const hasOtherCostChange = item.NewOtherNetCost !== undefined && Number(item.NewOtherNetCost || 0) !== Number(item.OtherNetCost || 0);
                const hasConditionCostChange = item.NewNetConditionCost !== undefined && Number(item.NewNetConditionCost || 0) !== Number(item.NetConditionCost || 0);

                // Check if values have actually changed from original values
                const basicRateChanged = hasBasicRateChange && ((item.NewBasicRate !== undefined || item.NewBasicrateFromPercentage) ?
                    Number(item.NewBasicRate || item.NewBasicrateFromPercentage || 0) : Number(item.BasicRate || 0)) !== Number(item.BasicRatePerUOM);
                const scrapRateChanged = hasScrapRateChange && Number(item.NewScrapRate || 0) !== Number(item.ScrapRate || 0);

                // For Exchange Rate simulation (check === true), include all items regardless of RM price changes
                // For regular RM simulation, only include items with actual changes
                if (check || ((hasBasicRateChange || hasScrapRateChange || hasOtherCostChange || hasConditionCostChange) &&
                    (basicRateChanged || scrapRateChanged || hasOtherCostChange || hasConditionCostChange))) {
                    let tempObj = {
                        IsAppliedChanges: true,
                        CostingHead: item.CostingHead === 'Vendor Based' ? VBC : ZBC,
                        RawMaterialId: item.RawMaterialId,
                        NewRawMaterialId: item.NewRawMaterialId ? item.NewRawMaterialId : null,
                        PlantId: item.PlantId,
                        RawMaterialName: item.RawMaterialName,
                        RawMaterialGrade: item.RawMaterialGradeName,
                        RawMaterialSpecification: item.RawMaterialSpecificationName,
                        MaterialType: item.MaterialType,
                        RawMaterialCategory: item.Category,
                        RawMaterialEntryType: item.RawMaterialEntryType || 0, // Assuming a default value
                        UOM: item.UnitOfMeasurementName,
                        OldBasicRate: isbulkUpload ? item.BasicRate : item.BasicRatePerUOM,
                        NewBasicRate: item.NewBasicRate ? item.NewBasicRate : item.NewBasicrateFromPercentage ? item.NewBasicrateFromPercentage : item.BasicRate,
                        OldScrapRate: item.ScrapRate,
                        NewScrapRate: item.NewScrapRate ? item.NewScrapRate : item.ScrapRate,
                        RawMaterialFreightCost: checkForNull(item.RMFreightCost),
                        RawMaterialShearingCost: checkForNull(item.RMShearingCost),
                        OldNetLandedCost: item.NetLandedCost,
                        NewNetLandedCost: preciseAdd(
                            Number(item.NewBasicrateFromPercentage !== undefined && item.NewBasicrateFromPercentage !== null ? item.NewBasicrateFromPercentage : (item.NewBasicRate ? item.NewBasicRate : item.BasicRate)),
                            (getConfigurationKey()?.IsShowFreightAndShearingCostFields ? preciseAdd(checkForNull(item.RMShearingCost), checkForNull(item.RMFreightCost)) : 0),
                            checkForNull(item.NewNetConditionCost),
                            checkForNull(item.NewOtherNetCost)
                        ),
                        EffectiveDate: item?.EffectiveDate && item?.EffectiveDate?.includes('T') ? item?.EffectiveDate : item?.EffectiveDate?.split("/")?.reverse()?.join("-") + "T00:00:00",
                        VendorId: item.VendorId,
                        Delta: 0,
                        OldScrapRatePerScrapUOM: item.ScrapRatePerScrapUOM,
                        NewScrapRatePerScrapUOM: item.NewScrapRatePerScrapUOM,
                        NewNetConditionCost: item.NewNetConditionCost || 0,
                        NewOtherNetCost: item.NewOtherNetCost || 0,
                        NewNetCostWithoutConditionCost: preciseAdd(
                            Number(item.NewBasicrateFromPercentage !== undefined && item.NewBasicrateFromPercentage !== null ? item.NewBasicrateFromPercentage : (item.NewBasicRate ? item.NewBasicRate : item.BasicRate)),
                            checkForNull(item.NewOtherNetCost)
                        ) || 0,
                        RawMaterialConditionsDetails: item.NewRawMaterialConditionCostDetails || [],
                        RawMaterialOtherCostDetails: item.NewRawMaterialOtherCostDetails || []
                    };
                    tempArr.push(tempObj);
                }
                return null;
            });
        } else {
            list && list.map(item => {
                let tempObj = {}
                tempObj.CostingHead = item.CostingHead === 'Vendor Based' ? VBC : ZBC
                tempObj.RawMaterialName = item.RawMaterialName
                tempObj.MaterialType = item.MaterialType
                tempObj.RawMaterialGrade = item.RawMaterialGradeName
                tempObj.RawMaterialSpecification = item.RawMaterialSpecificationName
                tempObj.RawMaterialCategory = item.Category
                tempObj.UOM = item.UnitOfMeasurementName
                tempObj.OldBasicRate = isbulkUpload ? item.BasicRate : item.BasicRatePerUOM
                tempObj.NewBasicRate = item.NewBasicRate ? item.NewBasicRate : (item.NewBasicrateFromPercentage !== 0 && item.NewBasicrateFromPercentage !== null && item.NewBasicrateFromPercentage !== undefined) ? item.NewBasicrateFromPercentage : (isbulkUpload ? item.BasicRate : item.BasicRatePerUOM)
                tempObj.OldScrapRate = item.ScrapRate
                tempObj.NewScrapRate = item.NewScrapRate ? item.NewScrapRate : item.ScrapRate
                tempObj.RawMaterialFreightCost = checkForNull(item.RMFreightCost)
                tempObj.RawMaterialShearingCost = checkForNull(item.RMShearingCost)
                tempObj.OldNetLandedCost = item.NetLandedCost
                // Use the same priority logic for basic rate as used throughout the component
                const effectiveBasicRate = item.NewBasicrateFromPercentage !== undefined && item.NewBasicrateFromPercentage !== null
                    ? item.NewBasicrateFromPercentage
                    : (item.NewBasicRate ? item.NewBasicRate : item.BasicRate);

                tempObj.NewNetLandedCost = preciseAdd(checkForNull(effectiveBasicRate), (getConfigurationKey()?.IsShowFreightAndShearingCostFields ? preciseAdd(checkForNull(item.RMShearingCost), checkForNull(item.RMFreightCost)) : 0), checkForNull(item.NewNetConditionCost), checkForNull(item.NewOtherNetCost))
                tempObj.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(effectiveBasicRate), checkForNull(item.NewOtherNetCost))
                tempObj.EffectiveDate = item.EffectiveDate
                tempObj.RawMaterialId = item.RawMaterialId
                tempObj.PlantId = item.PlantId
                tempObj.VendorId = item.VendorId
                tempObj.Delta = 0
                tempObj.OldScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                tempObj.NewScrapRatePerScrapUOM = item.NewScrapRatePerScrapUOM
                tempObj.NewNetConditionCost = item.NewNetConditionCost || 0
                tempObj.NewOtherNetCost = item.NewOtherNetCost || 0
                tempObj.RawMaterialConditionsDetails = item.NewRawMaterialConditionCostDetails || []
                tempObj.RawMaterialOtherCostDetails = item.NewRawMaterialOtherCostDetails || []

                tempArr.push(tempObj)

                return null;
            })
        }


        obj.SimulationIds = tokenForMultiSimulation
        obj.SimulationRawMaterials = tempArr
        if (check) {
            obj.SimulationExchangeRates = tempList
            obj.IsExchangeRateSimulation = true
        }
        if (String(selectedTechnologyForSimulation?.value) === String(PAINTTECHNOLOGY)) {
            obj.IsPaintSimulation = true
        }       

        obj.EffectiveDate = DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss')
        dispatch(runVerifySimulation(obj, res => {
            setIsDisable(false)

            if (res?.data?.Result) {
                setToken(res?.data?.Identity)
                setShowVerifyPage(true)
            }
        }))
    }

    const verifySimulation = debounce(() => {
        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }
        let netLandedCostChangeCount = 0
        let scrapRateChangeArr = [];
        let basicRateZeroCount = 0
        let scrapRateValidationErrors = [];

        list && list.map((li) => {
            const oldNetLandedCost = Number(li.NetLandedCost)
            const newNetLandedCost = Number(preciseAdd(
                checkForNull(li?.NewBasicRate || li?.BasicRatePerUOM),
                checkForNull(li?.NewOtherNetCost),
                (getConfigurationKey()?.IsShowFreightAndShearingCostFields ? preciseAdd(checkForNull(li?.RMFreightCost), checkForNull(li?.RMShearingCost)) : 0),
                checkForNull(li?.NewNetConditionCost)
            ))

            if (oldNetLandedCost === newNetLandedCost) {
                netLandedCostChangeCount = netLandedCostChangeCount + 1
            }
            if (oldNetLandedCost !== newNetLandedCost &&
                (Number(li.ScrapRate) === Number(li?.NewScrapRate || li.ScrapRate))) {
                scrapRateChangeArr.push(li)
            }

            // Check the effective basic rate using the same priority logic used throughout the component
            let effectiveBasicRate = 0;
            if (li?.NewBasicrateFromPercentage !== undefined && li?.NewBasicrateFromPercentage !== null) {
                effectiveBasicRate = Number(li?.NewBasicrateFromPercentage);
            } else if (li?.NewBasicRate && Number(li?.NewBasicRate) !== 0) {
                effectiveBasicRate = Number(li?.NewBasicRate);
            } else {
                effectiveBasicRate = Number(li?.BasicRatePerUOM || 0);
            }

            // Check the effective scrap rate
            let effectiveScrapRate = 0;
            if (li?.NewScrapRate && Number(li?.NewScrapRate) !== 0) {
                effectiveScrapRate = Number(li?.NewScrapRate);
            } else {
                effectiveScrapRate = Number(li?.ScrapRate || 0);
            }

            // Validate scrap rate vs basic rate relationship
            if (effectiveScrapRate > effectiveBasicRate) {
                scrapRateValidationErrors.push(li.RawMaterialCode || li.RawMaterialName);
            }

            if (effectiveBasicRate === 0) {
                basicRateZeroCount = basicRateZeroCount + 1
            }
            return null;
        })

        if ((selectedMasterForSimulation?.value === RMDOMESTIC || selectedMasterForSimulation?.value === RMIMPORT) &&
            netLandedCostChangeCount === list.length) {
            Toaster.warning('There is no changes in net cost. Please make changes to run simulation')
            return false
        }
        if (basicRateZeroCount > 0) {
            Toaster.warning('Basic Rate should not be zero')
            return false
        }
        if (scrapRateValidationErrors.length > 0) {
            let rmNameString = scrapRateValidationErrors.join(', ');
            Toaster.warning(`Scrap Rate should be less than Basic Rate for: ${rmNameString}`);
            return false;
        }

        // Unified popup logic for Exchange Rate simulation
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            let unchangedItemsCount = netLandedCostChangeCount;
            let changedItemsCount = list.length - unchangedItemsCount;
            let scrapRateNotChangedCount = scrapRateChangeArr.length;
            let messageLines = [];

            // Build dynamic message based on what was/wasn't changed
            if (unchangedItemsCount === list.length) {
                // No RM prices changed at all
                messageLines.push(`No Raw Material prices were changed.`);
                messageLines.push(`Only exchange rate changes will be applied.`);
            } else if (unchangedItemsCount > 0) {
                // Some RM prices not changed
                messageLines.push(`${changedItemsCount} out of ${list.length} Raw Material price(s) changed.`);
                messageLines.push(`${unchangedItemsCount} Raw Material(s) will only have exchange rate impact.`);
            } else {
                // All RM prices changed - check scrap rate
                if (scrapRateNotChangedCount > 0) {
                    let rmName = [];
                    scrapRateChangeArr.map(item => rmName.push(item.RawMaterialCode));
                    let rmNameString = rmName.join(', ');
                    messageLines.push(`All Raw Material prices changed.`);
                    messageLines.push(`Scrap rate not changed for: ${rmNameString}.`);
                }
            }

            // Add scrap rate message if some items have scrap rate not changed
            if (scrapRateNotChangedCount > 0 && unchangedItemsCount > 0) {
                let rmName = [];
                scrapRateChangeArr.map(item => rmName.push(item.RawMaterialCode));
                let rmNameString = rmName.join(', ');
                messageLines.push(`Scrap rate not changed for: ${rmNameString}.`);
            }

            // Show popup if there's any message to display
            if (messageLines.length > 0) {
                setPopupMessage(messageLines.join(' ') + ' Do you want to continue?');
                setShowPopup(true);
                setShowTooltip(false);
                return false;
            }
        } else {
            // For regular RM simulation, keep existing scrap rate popup behavior
            if (scrapRateChangeArr.length !== 0) {
                let rmName = [];
                scrapRateChangeArr.map(item => rmName.push(item.RawMaterialCode));
                let rmNameString = rmName.join(', ');
                setPopupMessage(`Scrap rate is not changed for some raw material (${rmNameString}). Do you still wish to continue?`);
                setShowPopup(true);
                setShowTooltip(false);
                return false;
            }
        }

        setIsDisable(true)

        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                if (!res?.status && !res?.error) {
                    setValueFunction(true, res);
                }
            }))
        } else {
            setValueFunction(false, []);
        }
        setShowTooltip(false)
    }, 600)

    const cancelVerifyPage = () => {

        setShowVerifyPage(false)
    }
    const resetState = () => {
        gridApi?.setQuickFilter('');
        setTextFilterSearch('')
        gridOptions?.columnApi?.resetColumnState();
        gridOptions?.api?.setFilterModel(null);
        window.screen.width >= 1921 && gridRef?.current?.api?.sizeColumnsToFit();
    }

    /**
     * @method shearingCostFormatter
     * @description Renders buttons
     */
    const CostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        return cell != null ? cell : '-';
    }

    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? <span title={DayTime(cell).format('DD/MM/YYYY')}> {cell.includes("T") ? DayTime(cell).format('DD/MM/YYYY') : cell}</span> : '';
    }


    const costingHeadFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }
    const vendorFormatter = (props) => {
        return (<span title={isbulkUpload ? props?.value : props?.data.VendorName}>{isbulkUpload ? props?.value : props?.data.VendorName}</span>);
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (<span title={isbulkUpload ? row['Customer (Code)'] : row?.CustomerName}>{isbulkUpload ? row['Customer (Code)'] : row?.CustomerName}</span>);
    }

    const plantFormatter = (props) => {
        return (<span title={isbulkUpload ? props?.value : props?.data.DestinationPlantName}>{isbulkUpload ? props?.value : props?.data.DestinationPlantName}</span>);
    }
    const newBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        // Use the new validation function
        const validation = validateAndFormatValue(cell, props, "basicRate");

        // Calculate display value with clear priority
        let displayValue = 0;

        // Priority 1: Use percentage-calculated basic rate if percentage exists
        if (row?.NewBasicrateFromPercentage !== undefined && row?.NewBasicrateFromPercentage !== null) {
            displayValue = Number(row?.NewBasicrateFromPercentage);
        }
        // Priority 2: Use manually entered basic rate (when no percentage)
        else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            displayValue = Number(row?.NewBasicRate);
        }
        // Priority 3: Use validated cell entry
        else if (cell && validation.isValid) {
            displayValue = Number(validation.value);
        }
        // Priority 4: Use original basic rate
        else {
            displayValue = Number(row?.BasicRatePerUOM || 0);
        }

        const oldBasicRate = Number(row?.BasicRatePerUOM || 0);
        const newBasicRate = Number(displayValue || 0);

        // FIX Bug #1: Use row ID for element ID
        const rowId = row?.CostingId || row?.RawMaterialId;

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewBasicRate, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <PriceComparisonSpan
                            newValue={newBasicRate}
                            oldValue={oldBasicRate}
                            id={`newBasicRate-${rowId}`}
                            className={`form-control ${row?.Percentage && Number(row?.Percentage) !== 0 ? 'percentage-applied' : ''} basicRate_revised`}
                            title={displayValue}
                        >
                            {checkForDecimalAndNull(displayValue, 6)}
                        </PriceComparisonSpan>
                }

            </>
        )
    }

    const oldBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        const displayValue = cell && value ? Number(cell) : Number(row?.BasicRatePerUOM);
        return (
            <>
                {
                    isImpactedMaster ?
                        row?.OldBasicRate :
                        <span title={checkForDecimalAndNull(displayValue, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}>
                            {checkForDecimalAndNull(displayValue, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}
                        </span>
                }

            </>
        )
    }

    const newScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        // Use the new validation function
        const validation = validateAndFormatValue(cell, props, "scrapRate");

        // Calculate display value with consistent logic
        let displayValue = 0;

        // Priority 1: Use NewScrapRate if it exists (either from percentage calculation or manual entry)
        if (row?.NewScrapRate && Number(row?.NewScrapRate) !== 0) {
            displayValue = Number(row?.NewScrapRate);
        }
        // Priority 2: Use validated cell entry
        else if (cell && validation.isValid) {
            displayValue = Number(validation.value);
        }
        // Priority 3: Use original scrap rate
        else {
            displayValue = Number(checkForNull(row?.ScrapRate));
        }

        const oldScrapRate = Number(row?.ScrapRate || 0);
        const newScrapRate = Number(displayValue || 0);

        // FIX Bug #1: Use row ID for element ID
        const rowId = row?.CostingId || row?.RawMaterialId;

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewScrapRate, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <PriceComparisonSpan
                            newValue={newScrapRate}
                            oldValue={oldScrapRate}
                            id={`newScrapRate-${rowId}`}
                            className={`form-control ${row?.IsScrapUOMApply === 'Yes' ? 'disabled' : ''} ${row?.Percentage && Number(row?.Percentage) !== 0 ? 'percentage-applied' : ''}`}
                            title={displayValue}
                        >
                            {checkForDecimalAndNull(displayValue, 6)}
                        </PriceComparisonSpan>
                }
            </>
        )
    }
    const newScrapRateUOMFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const newScrapRateInOldUOM = checkForDecimalAndNull(cell * row?.CalculatedFactor, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)
        const value = beforeSaveCell(newScrapRateInOldUOM, props, "scrapRate")
        if (value && !isImpactedMaster) {
            row.NewScrapRate = newScrapRateInOldUOM
            row.NewScrapRatePerScrapUOM = cell
        }

        // FIX Bug #1: Use row ID for element ID
        const rowId = row?.CostingId || row?.RawMaterialId;

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewScrapRatePerScrapUOM, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <span id={`newScrapRate-${rowId}`} className={`form-control ${row?.IsScrapUOMApply === 'No' ? 'disabled' : ''}`} title={cell && value ? Number(checkForNull(cell)) : Number(checkForNull(row?.ScrapRatePerScrapUOM))}>{cell && value ? Number(checkForNull(cell)) : Number(checkForNull(row?.ScrapRatePerScrapUOM))}</span>
                }
            </>
        )
    }

    const oldScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        const displayValue = cell && value ? checkForNull(Number(cell)) : checkForNull(Number(row?.ScrapRate));
        return (
            <>
                {
                    isImpactedMaster ?
                        row?.OldScrapRate :
                        <span title={checkForDecimalAndNull(displayValue, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}>
                            {checkForDecimalAndNull(displayValue, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}
                        </span>
                }
            </>
        )
    }

    const oldScrapRateFormatterPerScrapUOM = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForNull(row?.OldScrapRatePerScrapUOM) :
                        <span title={cell && value ? checkForNull(Number(cell)) : Number(checkForNull(row?.ScrapRate))}>{cell && value ? checkForNull(Number(cell)) : checkForNull(Number(checkForNull(row?.ScrapRate)))}</span>
                }
            </>
        )
    }

    // const colorCheck = 

    const costFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return isImpactedMaster ? checkForDecimalAndNull(row?.OldNetLandedCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) : checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)
    }

    /**
  * @method beforeSaveCell
  * @description CHECK FOR ENTER NUMBER IN CELL using common validation
  */
    const beforeSaveCell = (cell, props, type) => {
        return validateRevisedRate(cell, props, type);
    }

    const NewcostFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (isbulkUpload) {
            const revisedCost = checkForNull(row?.NewBasicRate);
            const existingCost = checkForNull(row?.NetLandedCost);

            return (
                <PriceComparisonSpan
                    newValue={revisedCost}
                    oldValue={existingCost}
                    className="form-control"
                    title={checkForDecimalAndNull(revisedCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)}
                >
                    {checkForDecimalAndNull(revisedCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)}
                </PriceComparisonSpan>
            );
        }

        // Use the value calculated by ageValueGetterLanded (passed as props.value)
        let totalCost = props.value;

        // If no value from valueGetter, calculate manually as fallback
        if (!totalCost && totalCost !== 0) {
            // 1. Calculate Basic Price (Basic Rate with percentage + Other Cost)
            let basicPrice = 0;

            // Priority 1: If percentage-calculated basic rate exists, use it
            if (row?.NewBasicrateFromPercentage !== undefined && row?.NewBasicrateFromPercentage !== null) {
                basicPrice = preciseAdd(checkForNull(row?.NewBasicrateFromPercentage), checkForNull(row?.NewOtherNetCost || 0));
            }
            // Priority 2: Use stored Basic Price if available (when no percentage)
            else if (row?.NewNetCostWithoutConditionCost !== null && row?.NewNetCostWithoutConditionCost !== undefined && row?.NewNetCostWithoutConditionCost !== 0) {
                basicPrice = checkForNull(row?.NewNetCostWithoutConditionCost);
            }
            // Priority 3: Use manually entered Basic Rate (when no percentage)
            else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
                basicPrice = preciseAdd(checkForNull(row?.NewBasicRate), checkForNull(row?.NewOtherNetCost || 0));
            }
            // Priority 4: Use original Basic Rate
            else {
                basicPrice = preciseAdd(checkForNull(row?.BasicRatePerUOM || 0), checkForNull(row?.NewOtherNetCost || 0));
            }

            // 2. Add Condition Cost
            let conditionCost = checkForNull(row?.NewNetConditionCost || 0);

            // 3. Add Freight and Shearing costs
            let freightAndShearing = 0;
            if (getConfigurationKey()?.IsShowFreightAndShearingCostFields) {
                freightAndShearing = preciseAdd(checkForNull(row?.RMFreightCost || 0), checkForNull(row?.RMShearingCost || 0));
            }

            // Net Cost = Basic Price + Condition Cost + Freight + Shearing (NO SCRAP RATE)
            totalCost = preciseAdd(basicPrice, conditionCost, freightAndShearing);
        }

        const existingCost = checkForDecimalAndNull(row?.NetLandedCost || 0);

        let displayValue = checkForDecimalAndNull(totalCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        return (
            <PriceComparisonSpan
                newValue={totalCost}
                oldValue={existingCost}
                className="form-control"
                title={displayValue}
            >
                {displayValue}
            </PriceComparisonSpan>
        )
    }
    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text '>Revised {!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const revisedScrapRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text'>Revised {!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"scrapRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const cancel = () => {
        list && list.map((item) => {
            item.NewBasicRate = undefined
            item.NewScrapRate = undefined
            return null
        })
        props.backToSimulation()
        // setShowMainSimulation(true)                    //RE
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)

    }


    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        editable: true
    };

    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {

        gridApi?.setQuickFilter(e?.target?.value);
        setTextFilterSearch(e?.target?.value)
    }
    const cellChange = (props) => {
        const rowData = props?.data;
        // FIX Bug #1: Get row ID for ID-based operations (filter/sort safe)
        const rowId = rowData?.CostingId || rowData?.RawMaterialId;

        if (rowData && props?.colDef && props?.colDef?.colId === 'Percentage') {
            // Validate percentage value before applying
            const validation = validateAndFormatValue(rowData.Percentage, props, 'percentage');
            if (!validation.isValid) {
                // FIX Bug #1: Find index using ID, not visual rowIndex
                const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
                if (rowIndexInList !== -1) {
                    resetFieldToLastValidValue(rowData, 'percentage', props, gridApi, list, rowIndexInList);
                }
                return;
            }

            // Apply percentage calculation using the optimized function
            applyPercentageCalculation(rowData, rowData.Percentage);

            // FIX Bug #1: Update list using ID-based lookup
            const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
            if (rowIndexInList !== -1) {
                Object.assign(list[rowIndexInList], rowData);
            }

            // FIX Bug #6: Remove setTimeout delay and use direct node update
            if (gridApi) {
                // Update using node.setData() which is more efficient
                props.node.setData(rowData);

                // Optional: Refresh only if needed for visual update
                gridApi.refreshCells({
                    rowNodes: [props.node],
                    columns: ['NewBasicRate', 'NewScrapRate', 'NewNetCostWithoutConditionCost', 'NewNetLandedCost', 'Percentage'],
                    force: false
                });
            }
        }

        // Handle manual basic rate entry - reset percentage for that specific record
        if (rowData && props?.colDef && props?.colDef?.colId === 'NewBasicRate') {
            // Validate basic rate before processing
            const validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
            if (!validation.isValid) {
                // FIX Bug #1: Find index using ID, not visual rowIndex
                const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
                if (rowIndexInList !== -1) {
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, rowIndexInList);
                }
                return;
            }

            if (rowData.NewBasicRate && Number(rowData.NewBasicRate) !== 0) {
                // Clear percentage-related fields when user enters manual basic rate
                rowData.NewBasicrateFromPercentage = undefined;
                rowData.Percentage = 0; // Set to 0 instead of undefined for better UI display

                // Recalculate costs with the new manual basic rate
                const manualBasicRate = checkForNull(rowData?.NewBasicRate);
                rowData.NewNetCostWithoutConditionCost = preciseAdd(manualBasicRate, checkForNull(rowData?.NewOtherNetCost || 0));

                // Calculate final Net Cost
                const conditionCost = checkForNull(rowData?.NewNetConditionCost || 0);
                const freightAndShearing = getConfigurationKey()?.IsShowFreightAndShearingCostFields ?
                    preciseAdd(checkForNull(rowData?.RMFreightCost || 0), checkForNull(rowData?.RMShearingCost || 0)) : 0;

                rowData.NewNetLandedCost = preciseAdd(rowData.NewNetCostWithoutConditionCost, conditionCost, freightAndShearing);

                // FIX Bug #1: Update list using ID-based lookup
                const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
                if (rowIndexInList !== -1) {
                    list[rowIndexInList].NewBasicRate = Number(rowData.NewBasicRate);
                    list[rowIndexInList].NewBasicrateFromPercentage = undefined;
                    list[rowIndexInList].Percentage = 0; // Explicitly set to 0
                    list[rowIndexInList].NewNetCostWithoutConditionCost = rowData.NewNetCostWithoutConditionCost;
                    list[rowIndexInList].NewNetLandedCost = rowData.NewNetLandedCost;
                }

                // FIX Bug #6: Remove setTimeout delay and DOM manipulation, use AG Grid API directly
                if (gridApi) {
                    // Update using node.setData() which is more efficient than manual DOM updates
                    props.node.setData(rowData);

                    // Optional: Refresh only if needed for visual update
                    gridApi.refreshCells({
                        rowNodes: [props?.node],
                        columns: ['NewBasicRate', 'Percentage', 'NewNetCostWithoutConditionCost', 'NewNetLandedCost'],
                        force: false
                    });
                }
            }
        }

        // Handle scrap rate changes
        if (rowData && props?.colDef && props?.colDef?.colId === 'NewScrapRate') {
            // Validate scrap rate before processing
            const validation = validateAndFormatValue(rowData.NewScrapRate, props, 'scrapRate');
            if (!validation.isValid) {
                // FIX Bug #1: Find index using ID, not visual rowIndex
                const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
                if (rowIndexInList !== -1) {
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, list, rowIndexInList);
                }
                return;
            }
        }
    }

    const onCellValueChanged = (props) => {
        const rowData = props?.data
        const rowId = rowData?.CostingId || rowData?.RawMaterialId;

        // Save undo state before making changes (only if not in impacted master mode and value actually changed)
        if (!isImpactedMaster && rowId && props?.oldValue !== props?.newValue) {
            // Create a snapshot of the row BEFORE the change
            const oldData = { ...rowData, [props.colDef.field]: props?.oldValue };
            saveUndoState(oldData, `Edit ${props.colDef.headerName || props.colDef.field}`);
        }

        if (rowData) {
            // Validate the changed value based on the column
            let validation = null;
            if (props?.colDef?.colId === 'NewBasicRate') {
                validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props?.node?.rowIndex);
                    return;
                }
            } else if (props?.colDef?.colId === 'NewScrapRate') {
                validation = validateAndFormatValue(rowData.NewScrapRate, props, 'scrapRate');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, list, props?.node?.rowIndex);
                    return;
                }
            } else if (props?.colDef?.colId === 'Percentage') {
                validation = validateAndFormatValue(rowData.Percentage, props, 'percentage');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'percentage', props, gridApi, list, props?.node?.rowIndex);
                    return;
                }
            }

            setBasicRate(rowData?.NewBasicRate)
            setNetCostWithoutConditionCost(rowData?.NewNetCostWithoutConditionCost)
        }

        // Also call the cellChange function to handle our custom logic
        cellChange(props)
    }

    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }
    const EditableCallbackForPercentage = (props) => {
        // Disable individual row percentage editing - only header percentage should be editable
        return false
    }
    const EditableCallbackForNewBasicRate = (props) => {
        // Always allow editing of basic rate - if percentage is set and user enters manual basic rate,
        // the percentage will be reset for that specific record
        // FIX Bug #1: Removed setRowIndex as it's no longer used (replaced with editRowId)
        return true
    }

    const EditableCallbackForNewScrapRate = (props) => {
        const rowData = props?.data;
        let value = false
        if (rowData?.IsScrapUOMApply === 'No') {
            value = false
        } else {
            value = true
        }
        return value
    }

    const EditableCallbackForNewScrapRateSecond = (props) => {
        const rowData = props?.data;
        let value = false
        if (rowData?.IsScrapUOMApply === 'Yes') {
            value = false
        } else {
            value = true
        }
        return value
    }

    const ageValueGetterPer = (params) => {
        let row = params.data
        if (!row?.Percentage) {
            if (row?.NewBasicRate) {
                return 0
            }
            return row?.BasicRatePerUOM * 0;
        } else {
            return row?.Percentage
        }
    };

    const percentageFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        // Use the new validation function
        const validation = validateAndFormatValue(cell, props, 'percentage');

        // Additional percentage-specific validation
        let cellValue = cell;
        if (cell && Number(cell) > 100) {
            Toaster.warning("Percentage should be less than or equal to 100");
            // FIX Bug #1: Use ID-based lookup instead of rowIndex
            const rowData = props?.data;
            const rowId = rowData?.CostingId || rowData?.RawMaterialId;
            const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
            if (rowIndexInList !== -1) {
                list[rowIndexInList].Percentage = 0;
            }
            cellValue = 0;
        }

        // FIX Bug #1: Use rowId for element ID to ensure uniqueness across filtered grids
        const rowData = props?.data;
        const rowId = rowData?.CostingId || rowData?.RawMaterialId;

        return (
            <>
                {
                    <span id={`percentage${rowId}`} className={`form-control disabled`} >
                        {cell && validation.isValid ? Number(cellValue) : (row?.Percentage !== undefined && row?.Percentage !== null ? row?.Percentage : 0)}
                    </span>
                }
            </>
        )
    }

    /**
     * @method hyphenFormatter
     */
    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return cellValue ? cellValue : '-';
    }

    const otherCostDrawer = (value, row, index, type) => {

        setRowData(row)

        // Get the correct basic rate value with proper priority
        let currentBasicRate = 0;
        if (row?.NewBasicrateFromPercentage !== undefined && row?.NewBasicrateFromPercentage !== null) {
            currentBasicRate = row?.NewBasicrateFromPercentage;
        } else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            currentBasicRate = row?.NewBasicRate;
        } else {
            currentBasicRate = row?.BasicRatePerUOM || 0;
        }

        setBasicRate(currentBasicRate)
        const rowId = row?.CostingId || row?.RawMaterialId; // Store row ID for filter/sort safety

        if (type === 'Old') {
            setOtherCostDetailForRow(row?.RawMaterialOtherCostDetails || [])
            setIsViewFlag(true)
            setEditRowId(rowId)
        } else {
            setOtherCostDetailForRow(isImpactedMaster ? row?.SimulationRawMaterialOtherCostDetailsList || [] : row?.NewRawMaterialOtherCostDetails || []);            // setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false)
            setIsViewFlag(false)
            setEditRowId(rowId)
        }
        setOpenOtherCostDrawer(true)

    }

    const conditionCostDrawer = (value, row, index, type) => {
        setRowData(row)

        // Get the correct basic rate value with proper priority
        let currentBasicRate = 0;
        if (row?.NewBasicrateFromPercentage !== undefined && row?.NewBasicrateFromPercentage !== null) {
            currentBasicRate = row?.NewBasicrateFromPercentage;
        } else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            currentBasicRate = row?.NewBasicRate;
        } else {
            currentBasicRate = row?.BasicRatePerUOM || 0;
        }

        setBasicRate(currentBasicRate)
        const rowId = row?.CostingId || row?.RawMaterialId; // Store row ID for filter/sort safety

        if (type === 'Old') {
            setConditionCostDetailForRow(row?.RawMaterialConditionsDetails || [])
            setIsViewFlag(true)
            setEditRowId(rowId)
        } else {
            setConditionCostDetailForRow(isImpactedMaster ? row?.SimulationRawMaterialConditionsDetails || [] : row?.NewRawMaterialConditionCostDetails || [])
            // setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false)
            setIsViewFlag(false)
            setEditRowId(rowId)
        }
        setOpenConditionCostDrawer(true)

    }

    const calculateAndSave = (tableData, totalCostBase) => {
        setIsLoader(true)

        // CRITICAL: Find row by ID instead of index (filter/sort safe)
        const actualIndex = list.findIndex(item =>
            (item.CostingId || item.RawMaterialId) === editRowId
        );

        if (actualIndex === -1) {
            console.error('Row not found for editRowId:', editRowId);
            setIsLoader(false);
            return;
        }

        list[actualIndex].NewOtherNetCost = totalCostBase
        list[actualIndex].NewOtherNetCostConversion = totalCostBase
        list[actualIndex].NewOtherNetCostLocalConversion = totalCostBase
        list[actualIndex].NewRawMaterialOtherCostDetails = tableData

        // Get the correct basic rate value with proper priority
        let currentBasicRate = 0;
        const item = list[actualIndex];
        if (item?.NewBasicrateFromPercentage !== undefined && item?.NewBasicrateFromPercentage !== null) {
            currentBasicRate = item?.NewBasicrateFromPercentage;
        } else if (item?.NewBasicRate && Number(item?.NewBasicRate) !== 0) {
            currentBasicRate = item?.NewBasicRate;
        } else {
            currentBasicRate = item?.BasicRatePerUOM || 0;
        }

        list[actualIndex].NewNetCostWithoutConditionCost = preciseAdd(checkForNull(currentBasicRate), checkForNull(totalCostBase));
        setNetCostWithoutConditionCost(preciseAdd(checkForNull(currentBasicRate), checkForNull(totalCostBase)));

        // OPTIMIZED: Single refresh using ID-based node finding
        if (gridApi && editRowId) {
            const node = findNodeByRowId(editRowId);
            if (node) {
                node.setData(list[actualIndex]);
            }
        }

        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }

    const calculateAndSaveCondition = (tableData, totalCostBase) => {
        setIsLoader(true)

        // CRITICAL: Find row by ID instead of index (filter/sort safe)
        const actualIndex = list.findIndex(item =>
            (item.CostingId || item.RawMaterialId) === editRowId
        );

        if (actualIndex === -1) {
            console.error('Row not found for editRowId:', editRowId);
            setIsLoader(false);
            return;
        }

        list[actualIndex].NewNetConditionCost = totalCostBase
        list[actualIndex].NewConditionNetCostConversion = totalCostBase
        list[actualIndex].NewConditionNetCostLocalConversion = totalCostBase
        list[actualIndex].NewRawMaterialConditionCostDetails = tableData

        // OPTIMIZED: Single refresh using ID-based node finding
        if (gridApi && editRowId) {
            const node = findNodeByRowId(editRowId);
            if (node) {
                node.setData(list[actualIndex]);
            }
        }

        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }

    const closeOtherCostDrawer = (type, tableData, totalCostCurrency, totalCostBase, RowIndex) => {
        if (type === 'Save') {
            calculateAndSave(tableData, totalCostBase)
        } else {
            // If canceling, revert to the original RawMaterialOtherCostDetails
            const actualIndex = list.findIndex(item =>
                (item.CostingId || item.RawMaterialId) === editRowId
            );
            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.RawMaterialOtherCostDetails || [];
                setOtherCostDetailForRow(originalDetails);
            }
        }
        setOpenOtherCostDrawer(false)
        setIsViewFlag(false)
        // setOtherCostDetailForRow([])
    }

    const closeConditionCostDrawer = (type, tableData, totalCostCurrency, conditionCost) => {
        if (type === 'save') {
            const newConditionCost = tableData.reduce((acc, item) => preciseAdd(checkForNull(acc), checkForNull(item?.ConditionCostPerQuantity || 0)), 0);
            calculateAndSaveCondition(tableData, newConditionCost)
        } else {
            // If canceling, revert to the original RawMaterialOtherCostDetails
            const actualIndex = list.findIndex(item =>
                (item.CostingId || item.RawMaterialId) === editRowId
            );
            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.RawMaterialConditionsDetails || [];
                setConditionCostDetailForRow(originalDetails);
            }
        }
        setOpenConditionCostDrawer(false)
        setIsViewFlag(false)
        // setOtherCostDetailForRow([])
    }

    const existingOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')

        // Fix NaN in title attribute by using checkForNull
        const titleValue = cell && value ? Number(cell) : checkForNull(row?.OldNetConditionCost);

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row?.OldOtherCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <span title={titleValue}>{cell && value ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row?.OtherNetCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)} </span>

                }
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const existingConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell, props, 'otherCost')

        // Fix NaN in title attribute by using checkForNull
        const titleValue = cell && value ? Number(cell) : checkForNull(row?.OldNetConditionCost);

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row?.OldNetConditionCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <span title={titleValue}>{cell && value ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row?.OldNetConditionCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)} </span>

                }
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const revisedOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row?.OtherNetCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)

        const newOtherCost = checkForDecimalAndNull(row?.NewOtherNetCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        const oldOtherCost = checkForDecimalAndNull(row?.OtherNetCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        // FIX Bug #1: Removed setRowIndex as it's no longer used (replaced with editRowId)

        return (
            <div className="cell-with-button">
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewOtherCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <PriceComparisonSpan
                            newValue={newOtherCost}
                            oldValue={oldOtherCost}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </div>
        )
    }

    const revisedConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row?.NetConditionCost), isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)

        const newConditionCost = checkForDecimalAndNull(row?.NewNetConditionCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        const oldConditionCost = checkForDecimalAndNull(row?.NetConditionCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        // FIX Bug #1: Removed setRowIndex as it's no longer used (replaced with editRowId)

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row?.NewNetConditionCost, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6) :
                        <PriceComparisonSpan
                            newValue={newConditionCost}
                            oldValue={oldConditionCost}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => ConditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    // Optimized function to handle percentage-based calculations for a row
    const applyPercentageCalculation = (item, percentage) => {
        if (percentage && Number(percentage) !== 0) {
            const originalBasicRate = checkForNull(item?.BasicRatePerUOM || 0);
            const percentageIncrease = preciseMultiply(originalBasicRate, preciseDivide(checkForNull(percentage), 100));
            const basicRateWithPercentage = preciseAdd(originalBasicRate, percentageIncrease);

            // Store the percentage-calculated basic rate
            item.NewBasicrateFromPercentage = basicRateWithPercentage;
            item.NewBasicRate = undefined; // Clear manual entry

            // Update Scrap Rate with percentage
            const originalScrapRate = checkForNull(item?.ScrapRate || 0);
            const scrapPercentageIncrease = preciseMultiply(originalScrapRate, preciseDivide(checkForNull(percentage), 100));
            item.NewScrapRate = preciseAdd(originalScrapRate, scrapPercentageIncrease);

            // Recalculate other costs if they have basic rate applicability
            if (item?.NewRawMaterialOtherCostDetails?.length > 0) {
                const hasBasicRateApplicability = item.NewRawMaterialOtherCostDetails.some(cost =>
                    cost.Applicability === 'Basic Rate' || cost.ApplicabilityId === 1
                );

                if (hasBasicRateApplicability) {
                    item.otherCostTableData = item.NewRawMaterialOtherCostDetails;
                    const updatedObjOtherCost = updateCostValue(false, item, basicRateWithPercentage, true);
                    if (updatedObjOtherCost?.tableData && updatedObjOtherCost?.formValue?.value !== undefined) {
                        item.NewRawMaterialOtherCostDetails = updatedObjOtherCost.tableData;
                        item.NewOtherNetCost = updatedObjOtherCost.formValue.value;
                    }
                }
            }

            // Calculate Basic Price = Basic Rate + Other Cost
            item.NewNetCostWithoutConditionCost = preciseAdd(basicRateWithPercentage, checkForNull(item?.NewOtherNetCost || 0));

            // Recalculate condition costs if they have basic price applicability
            if (item?.NewRawMaterialConditionCostDetails?.length > 0) {
                const hasBasicPriceApplicability = item.NewRawMaterialConditionCostDetails.some(cost =>
                    cost.Applicability === 'Basic Price' || cost.ApplicabilityId === 2
                );

                if (hasBasicPriceApplicability) {
                    item.conditionTableData = item.NewRawMaterialConditionCostDetails;
                    const basicPrice = preciseAdd(basicRateWithPercentage, checkForNull(item?.NewOtherNetCost || 0));
                    const updatedObjConditionCost = updateCostValue(true, item, basicPrice, true);
                    if (updatedObjConditionCost?.tableData && updatedObjConditionCost?.formValue?.value !== undefined) {
                        item.NewRawMaterialConditionCostDetails = updatedObjConditionCost.tableData;
                        item.NewNetConditionCost = updatedObjConditionCost.formValue.value;
                    }
                }
            }

            // Calculate final Net Cost
            const conditionCost = checkForNull(item?.NewNetConditionCost || 0);
            const freightAndShearing = getConfigurationKey()?.IsShowFreightAndShearingCostFields ?
                preciseAdd(checkForNull(item?.RMFreightCost || 0), checkForNull(item?.RMShearingCost || 0)) : 0;

            item.NewNetLandedCost = preciseAdd(item.NewNetCostWithoutConditionCost, conditionCost, freightAndShearing);

        } else {
            // Reset to original values when percentage is cleared
            item.NewBasicrateFromPercentage = undefined;
            item.NewBasicRate = undefined;
            item.NewScrapRate = undefined;
            item.Percentage = 0; // Explicitly set to 0 for UI consistency
            item.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(item?.BasicRatePerUOM || 0), checkForNull(item?.NewOtherNetCost || 0));

            // Recalculate Net Cost without percentage
            const conditionCost = checkForNull(item?.NewNetConditionCost || 0);
            const freightAndShearing = getConfigurationKey()?.IsShowFreightAndShearingCostFields ?
                preciseAdd(checkForNull(item?.RMFreightCost || 0), checkForNull(item?.RMShearingCost || 0)) : 0;

            item.NewNetLandedCost = preciseAdd(item.NewNetCostWithoutConditionCost, conditionCost, freightAndShearing);
        }
    };

    const changeList = (value) => {
        setIsLoader(true)
        list && list?.map(item => {
            item.Percentage = value;
            applyPercentageCalculation(item, value);
            return null;
        })

        // Force refresh the grid after calculations
        setTimeout(() => {
            if (gridApi) {
                gridApi.refreshCells({
                    columns: ['NewBasicRate', 'NewScrapRate', 'NewNetCostWithoutConditionCost', 'NewNetLandedCost', 'Percentage'],
                    force: true
                });
                gridApi.redrawRows();
            }
            setIsLoader(false)
        }, 100);
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            changeList(e.target.value);
        }
    };

    const percentageHeader = () => {
        let value = '';
        const onHandler = (e) => {
            value = e.target.value
        }
        return (<div>
            <input type="text" className="form-control ag-grid-input" onChange={onHandler} onKeyPress={handleKeyPress} onBlur={() => changeList(value)} />
        </div>
        )
    }

    const zeroFormatter = (props) => {
        const cellValue = checkForDecimalAndNull(props?.value, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        return (cellValue !== ' ' && cellValue !== null && cellValue !== '' && cellValue !== undefined) ? cellValue : '0';
    }

    const basicPriceFormatter = (props) => {
        const row = props?.data;
        let displayValue = 0;
        // Priority 1: If percentage is applied, always recalculate (this overrides stored values)
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            const originalBasicRate = checkForNull(row?.BasicRatePerUOM || 0);
            const percentageIncrease = preciseMultiply(originalBasicRate, preciseDivide(checkForNull(row?.Percentage), 100));
            const basicRateWithPercentage = preciseAdd(originalBasicRate, percentageIncrease);
            displayValue = preciseAdd(basicRateWithPercentage, checkForNull(row?.NewOtherNetCost || 0));

            // Store the calculated value
            row.NewNetCostWithoutConditionCost = displayValue;


        }
        // Priority 2: Check if we already have a calculated Basic Price stored (only when no percentage)
        else if (row?.NewNetCostWithoutConditionCost !== null && row?.NewNetCostWithoutConditionCost !== undefined && row?.NewNetCostWithoutConditionCost !== 0) {
            displayValue = checkForNull(row?.NewNetCostWithoutConditionCost);
        }
        // Priority 3: If manual NewBasicRate exists (without percentage)
        else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            displayValue = preciseAdd(checkForNull(row?.NewBasicRate), checkForNull(row?.NewOtherNetCost || 0));
        }
        // Priority 4: Use original Basic Rate + Other Cost
        else {
            displayValue = preciseAdd(checkForNull(row?.BasicRatePerUOM || 0), checkForNull(row?.NewOtherNetCost || 0));
        }

        // Always store the calculated value for consistency
        row.NewNetCostWithoutConditionCost = displayValue;



        const formattedValue = checkForDecimalAndNull(displayValue, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6);
        return (formattedValue !== ' ' && formattedValue !== null && formattedValue !== '' && formattedValue !== undefined) ? formattedValue : '0';
    }

    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        return checkForDecimalAndNull(cellValue, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)
    }

    const frameworkComponents = {
        effectiveDateFormatter: effectiveDateFormatter,
        costingHeadFormatter: costingHeadFormatter,
        CostFormatter: CostFormatter,
        newScrapRateFormatter: newScrapRateFormatter,
        newScrapRateUOMFormatter: newScrapRateUOMFormatter,
        NewcostFormatter: NewcostFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newBasicRateFormatter: newBasicRateFormatter,
        cellChange: cellChange,
        oldBasicRateFormatter: oldBasicRateFormatter,
        oldScrapRateFormatter: oldScrapRateFormatter,
        vendorFormatter: vendorFormatter,
        customerFormatter: customerFormatter,
        plantFormatter: plantFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        revisedScrapRateHeader: revisedScrapRateHeader,
        ageValueGetterPer: ageValueGetterPer,
        percentageFormatter: percentageFormatter,
        percentageHeader: percentageHeader,
        nullHandler: props.nullHandler && props.nullHandler,
        oldScrapRateFormatterPerScrapUOM: oldScrapRateFormatterPerScrapUOM,
        hyphenFormatter: hyphenFormatter,
        existingOtherCostFormatter: existingOtherCostFormatter,
        revisedOtherCostFormatter: revisedOtherCostFormatter,
        existingConditionCostFormatter: existingConditionCostFormatter,
        revisedConditionCostFormatter: revisedConditionCostFormatter,
        zeroFormatter: zeroFormatter,
        basicPriceFormatter: basicPriceFormatter,
        localConversionFormatter: localConversionFormatter

    };

    const ageValueGetterLanded = (params) => {
        let row = params.data
        let valueReturn = 0;

        // 1. Calculate Net Cost based on Basic Rate Revised value
        let netCost = 0;
        let basicRateToUse = 0;

        // Always calculate the basic rate fresh to ensure we get the latest value
        if (row?.Percentage && Number(row?.Percentage) !== 0) {
            // Calculate basic rate with percentage
            const originalBasicRate = checkForNull(row?.BasicRatePerUOM || 0);
            const percentageIncrease = preciseMultiply(originalBasicRate, preciseDivide(checkForNull(row?.Percentage), 100));
            basicRateToUse = preciseAdd(originalBasicRate, percentageIncrease);

        } else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
            // Use manually entered basic rate
            basicRateToUse = checkForNull(row?.NewBasicRate);

        } else {
            // Use original basic rate
            basicRateToUse = checkForNull(row?.BasicRatePerUOM || 0);

        }

        // Calculate net cost = basic rate + other cost
        netCost = preciseAdd(basicRateToUse, checkForNull(row?.NewOtherNetCost || 0));

        // 2. Add Condition Cost
        let conditionCost = checkForNull(row?.NewNetConditionCost || 0);

        // 3. Add Freight and Shearing costs
        let freightAndShearing = 0;
        if (getConfigurationKey()?.IsShowFreightAndShearingCostFields) {
            freightAndShearing = preciseAdd(checkForNull(row?.RMFreightCost || 0), checkForNull(row?.RMShearingCost || 0));
        }

        // Net Cost = Basic Rate Revised + Other Cost + Condition Cost + Freight + Shearing (NO SCRAP RATE)
        valueReturn = preciseAdd(netCost, conditionCost, freightAndShearing);



        return valueReturn;
    };


    const ageValueGetterScrapRate = (params) => {
        let row = params.data
        let valueReturn = ''
        if (row?.IsScrapUOMApply === 'Yes') {
            valueReturn = checkForDecimalAndNull(row?.NewScrapRatePerScrapUOM * row?.CalculatedFactor, isImpactedMaster ? getConfigurationKey()?.NoOfDecimalForPrice : 6)
        } else {
            valueReturn = row?.NewScrapRate
        }
        return valueReturn
    }

    const closePopUp = () => {
        setShowPopup(false)
    }
    const onPopupConfirm = () => {
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                setValueFunction(true, res);
            }))
        } else {
            setValueFunction(false, []);
        }
        setShowPopup(false)
    }
    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }
    const scrapRatetooltipToggle = () => {
        setScrapRateViewTooltip(!scrapRateviewTooltip)
    }

    const onBtExport = () => {
        if (String(props?.masterId) === String(RMIMPORT)) {
            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl_IMPORT, list)
        } else {

            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl, list)
        }
    };

    const returnExcelColumn = (data = [], TempData) => {
        let temp = []
        TempData && TempData.forEach((item) => {
            let excelItem = { ...item }
            excelItem.EffectiveDate = (excelItem?.EffectiveDate)?.slice(0, 10)
            excelItem.NewNetLandedCost = excelItem?.NewNetLandedCost ?? excelItem?.NetLandedCost
            excelItem.NewScrapRate = excelItem?.NewScrapRate ?? excelItem?.ScrapRate
            excelItem.BasicRatePerUOM = isImpactedMaster ? excelItem?.OldBasicRate : excelItem?.BasicRatePerUOM
            excelItem.ScrapRate = isImpactedMaster ? excelItem?.OldScrapRate : excelItem?.ScrapRate
            excelItem.OtherNetCost = isImpactedMaster ? (excelItem?.OldOtherCost ?? 0) : excelItem?.OtherNetCost
            excelItem.NewOtherNetCost = isImpactedMaster ? excelItem?.NewOtherCost : excelItem?.OtherNetCost
            excelItem.NetLandedCost = isImpactedMaster ? excelItem?.OldNetLandedCost : excelItem?.NetLandedCost
            excelItem.ExchangeRate = item.EntryType === "Import" ? item?.ExchangeRate : undefined;
            Object.keys(excelItem).forEach(key => {
                if (excelItem[key] === null || excelItem[key] === undefined || excelItem[key] === '') {
                    excelItem[key] = "-";
                }
            });

            temp.push(excelItem)
        })

        const hasNonZeroBasedCosting = TempData && TempData?.some(item => item?.CostingHead !== "Zero Based");
        if (hasNonZeroBasedCosting) {
            data = data?.filter(column => !['NetCostWithoutConditionCost', 'NewNetCostWithoutConditionCost', 'NetConditionCost', 'NewNetConditionCost'].includes(column.value));
        }

        if (isImpactedMaster) {
            data = data.filter(column => !['CostingHead', 'VendorName', 'DestinationPlantName', 'Category', 'TechnologyName'].includes(column.value));
        } else {
            data = data.filter(column => !['LocalCurrency', 'PreviousMinimum', 'PreviousMaximum', 'PreviousAverage', 'Minimum', 'Maximum', 'Average', 'NewRMNetLandedCostConversion', 'ExchangeRate', 'OldRMNetLandedCostConversion', 'NewNetLandedCostLocalConversion', 'OldNetLandedCostLocalConversion'].includes(column.value));
        }
        return (
            <ExcelSheet data={temp} name={'RM Data'}>
                {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }

    return (

        <div>
            <div className={`ag-grid-react ${props.customClass}`}>
                {!showverifyPage &&
                    // {(!showverifyPage && !showMainSimulation) &&                    //RE
                    <Fragment>
                        {showTooltip && !isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised basic rate please double click on the field."}</Tooltip>}
                        {showTooltip && !isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={scrapRateviewTooltip} toggle={scrapRatetooltipToggle} target={"scrapRate-tooltip"} >{"To edit revised scrap rate please double click on the field."}</Tooltip>}
                        <Row>
                            <Col className="add-min-height mb-3 sm-edit-page">
                                <div className={`ag-grid-wrapper height-width-wrapper reset-btn-container ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                    <div className="ag-grid-header d-flex justify-content-between">
                                        <div className='d-flex align-items-center'>
                                            <input type="text" className="form-control mr-1 table-search" id="filter-text-box" value={textFilterSearch} placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            <button type="button" className="user-btn float-right mr-3 Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                            <ExcelFile filename={`${props.lastRevision ? 'Last Revision Data' : 'Impacted Master Data'}`} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile>
                                          
                                        </div>
                                        <div className='d-flex justify-content-end'>

                                            <div className="d-flex justify-content-end bulk-upload-row rm-row" style={{ marginRight: 0 }}>
                                                {
                                                    isbulkUpload && <>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows with changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfCorrectRow'}
                                                                Controller={Controller}
                                                                title={titleObj.rowWithChanges}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfCorrectRow}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows without changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfRowsWithoutChange'}
                                                                Controller={Controller}
                                                                title={titleObj.rowWithoutChanges}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfRowsWithoutChange}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </>}
                                                    {!isImpactedMaster && (
                                                <>
                                                    <UndoButton
                                                        undoCount={undoCount}
                                                        onUndo={handleUndo}
                                                        disabled={isImpactedMaster || !canUndo}
                                                        position="right"
                                                    />
                                                    <RedoButton
                                                        redoCount={redoCount}
                                                        onRedo={handleRedo}
                                                        disabled={isImpactedMaster || !canRedo}
                                                        position="right"
                                                    />
                                                </>
                                            )}
                                                {!isImpactedMaster && list && <div className={`d-flex align-items-center simulation-label-container`}>
                                                    <div className='d-flex'>
                                                        <label>{technologyLabel}: </label>
                                                        <p className='technology ml-1' title={list[0]?.TechnologyName}>{list[0]?.TechnologyName}</p>
                                                    </div>
                                                    {list[0]?.CostingTypeId !== CBCTypeId && <div className='d-flex pl-3'>
                                                        <label className='mr-1'>{vendorLabel} (Code):</label>
                                                        <p title={list[0]?.VendorName}>{list[0]?.VendorName ? list[0]?.VendorName : list?.[0]?.[`${vendorLabel} (Code)`]}</p>

                                                    </div>}
                                                    <button type="button" className={"apply ml-2 back_simulationPage"} id="simulation-back" onClick={cancel} disabled={isDisable}> <div className={'back-icon'}></div>Back</button>
                                                </div>}
                                            </div>


                                        </div>

                                    </div>
                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {isLoader && <LoaderCustom />}
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {list &&
                                            ((render || isLoader) ? <LoaderCustom customClass="loader-center" /> : (<AgGridReact

                                                ref={gridRef}
                                                floatingFilter={true}
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                domLayout='autoHeight'
                                                // columnDefs={c}
                                                rowData={list}
                                                pagination={true}
                                                paginationPageSize={defaultPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                loadingOverlayComponent={'customLoadingOverlay'}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressColumnVirtualisation={true}
                                                stopEditingWhenCellsLoseFocus={true}
                                                onCellValueChanged={onCellValueChanged}
                                                onFilterModified={onFloatingFilterChanged}
                                                enableBrowserTooltips={true}
                                            >
                                                {
                                                    !isImpactedMaster &&
                                                    <AgGridColumn minWidth={columnWidths?.CostingHead} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>
                                                }
                                                {<AgGridColumn minWidth={columnWidths?.EntryType} field="EntryType" headerName="Entry Type" cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>}
                                                <AgGridColumn minWidth={columnWidths?.RawMaterialName} field="RawMaterialName" tooltipField='RawMaterialName' editable='false' headerName="Raw Material"></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths?.RawMaterialGradeName} field="RawMaterialGradeName" tooltipField='RawMaterialGradeName' editable='false' headerName="Grade" ></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths?.RawMaterialSpecificationName} field="RawMaterialSpecificationName" tooltipField='RawMaterialSpecificationName' editable='false' headerName="Specification"></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths?.RawMaterialCode} field="RawMaterialCode" tooltipField='RawMaterialCode' editable='false' headerName='Code' cellRenderer='hyphenFormatter'></AgGridColumn>
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths?.Category} field="Category" tooltipField='Category' editable='false' headerName="Category"></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths?.TechnologyName} field="TechnologyName" tooltipField='TechnologyName' editable='false' headerName={technologyLabel} ></AgGridColumn>}
                                                {!isImpactedMaster && list[0]?.CostingTypeId !== CBCTypeId && <AgGridColumn minWidth={columnWidths?.VendorCod} field="Vendor (Code)" tooltipField='Vendor (Code)' editable='false' headerName={`${vendorLabel} (Code)`} cellRenderer='vendorFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && list[0]?.CostingTypeId === CBCTypeId && <AgGridColumn minWidth={columnWidths?.CustomerName} field="CustomerName" tooltipField='CustomerName' editable='false' headerName="Customer (Code)" cellRenderer='customerFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths?.PlantCode} field="Plant (Code)" editable='false' headerName="Plant (Code)" tooltipField='Plant (Code)' cellRenderer='plantFormatter' ></AgGridColumn>}
                                                <AgGridColumn minWidth={columnWidths?.UnitOfMeasurementName} field="UnitOfMeasurementName" tooltipField='UnitOfMeasurementName' editable='false' headerName="UOM"></AgGridColumn>
                                                {isScrapUOMApplyTemp && <AgGridColumn minWidth={columnWidths?.ScrapUnitOfMeasurement} field="ScrapUnitOfMeasurement" tooltipField='ScrapUnitOfMeasurement' editable='false' headerName="Scrap UOM" cellRenderer='hyphenFormatter'></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="CostingNumber" tooltipField='CostingNumber' editable='false' headerName="Costing No" minWidth={columnWidths?.CostingNumber}></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="PartNumber" tooltipField='PartNumber' editable='false' headerName="Part No" minWidth={columnWidths?.PartNumber}></AgGridColumn>}

                                                {/* {String(props?.masterId) === String(RMIMPORT) && <AgGridColumn field="Currency" tooltipField='Currency' editable='false' headerName="Currency" minWidth={140} ></AgGridColumn>} */}
                                                {(isImpactedMaster && String(props?.masterId) === String(RMIMPORT)) && <AgGridColumn field="ExchangeRate" tooltipField='ExchangeRate' editable='false' headerName="Existing Exchange Rate" minWidth={columnWidths?.ExchangeRate} ></AgGridColumn>}
                                                {getConfigurationKey()?.IsSourceExchangeRateNameVisible && <AgGridColumn minWidth={columnWidths?.ExchangeRateSourceName} field="ExchangeRateSourceName" headerName="Exchange Rate Source" editable='false'></AgGridColumn>}
                                                <AgGridColumn field="Currency" headerName="Currency/Settlement Currency" minWidth={columnWidths?.Currency} cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>
                                                {(isImpactedMaster || props?.lastRevision) && <AgGridColumn field="LocalCurrency" minWidth={columnWidths?.LocalCurrency} headerName={"Plant Currency"} cellRenderer={"currencyFormatter"} editable='false'></AgGridColumn>}

                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicRate.group} headerName={
                                                    "Basic Rate (Currency)"

                                                } marryChildren={true} pinned='right' >
                                                    <AgGridColumn width={columnWidths?.BasicRate.existing} field={isImpactedMaster ? "OldBasicRate" : "BasicRatePerUOM"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OldBasicRate" : "BasicRatePerUOM"} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.BasicRate.revised} editable={isImpactedMaster ? false : EditableCallbackForNewBasicRate} onCellValueChanged='cellChange' field="NewBasicRate" headerName="Revised" colId='NewBasicRate' headerComponent={'revisedBasicRateHeader'} cellRenderer={'newBasicRateFormatter'} pinned='right' valueGetter={(params) => {
                                                        const row = params.data;
                                                        // Priority 1: Use percentage-calculated basic rate if percentage exists
                                                        if (row?.NewBasicrateFromPercentage !== undefined && row?.NewBasicrateFromPercentage !== null) {
                                                            return Number(row?.NewBasicrateFromPercentage);
                                                        }
                                                        // Priority 2: Use manually entered basic rate (when no percentage)
                                                        else if (row?.NewBasicRate && Number(row?.NewBasicRate) !== 0) {
                                                            return Number(row?.NewBasicRate);
                                                        }
                                                        // Priority 3: Use original basic rate
                                                        else {
                                                            return Number(row?.BasicRatePerUOM || 0);
                                                        }
                                                    }} valueSetter={(params) => {
                                                        // Use the validation-enabled value setter
                                                        const isValid = valueSetter(params, 'basicRate');

                                                        if (isValid) {
                                                            // Clear percentage when manual basic rate is entered
                                                            const row = params.data;
                                                            const newValue = params.newValue;

                                                            if (newValue && Number(newValue) !== 0) {
                                                                row.NewBasicrateFromPercentage = undefined;
                                                                row.Percentage = 0;

                                                                // FIX Bug #1: Update list using ID-based lookup
                                                                const rowId = row?.CostingId || row?.RawMaterialId;
                                                                const rowIndexInList = list.findIndex(item => (item.CostingId || item.RawMaterialId) === rowId);
                                                                if (rowIndexInList !== -1) {
                                                                    list[rowIndexInList].NewBasicRate = newValue;
                                                                    list[rowIndexInList].NewBasicrateFromPercentage = undefined;
                                                                    list[rowIndexInList].Percentage = 0;
                                                                }
                                                            }
                                                        }

                                                        return isValid;
                                                    }}></AgGridColumn>
                                                </AgGridColumn>

                                                {!isImpactedMaster && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={"Percentage"} marryChildren={true} width={columnWidths?.Percentage.group} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.Percentage.field} editable={EditableCallbackForPercentage} onCellValueChanged='cellChange' field="Percentage" colId='Percentage' valueGetter={ageValueGetterPer} cellRenderer='percentageFormatter' headerComponent={'percentageHeader'} valueSetter={(params) => {
                                                        // Use the validation-enabled value setter
                                                        return valueSetter(params, 'percentage');
                                                    }} pinned='right'></AgGridColumn>
                                                </AgGridColumn>}
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ScrapRate.group} marryChildren={true} headerName={
                                                    "Scrap Rate (Currency)"

                                                } pinned='right'>
                                                    {isScrapUOMApplyTemp && <AgGridColumn width={columnWidths?.ScrapRatePerScrapUOM} field={isImpactedMaster ? "OldScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} editable='false' cellRenderer='oldScrapRateFormatterPerScrapUOM' headerName="Existing (In Scrap UOM)" colId={isImpactedMaster ? "ScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} pinned='right'></AgGridColumn>}
                                                    {isScrapUOMApplyTemp && <AgGridColumn width={columnWidths?.NewScrapRatePerScrapUOM} cellRenderer='newScrapRateUOMFormatter' field='NewScrapRatePerScrapUOM' headerName="Revised (In Scrap UOM)" colId={"NewScrapRatePerScrapUOM"} editable={isImpactedMaster ? false : EditableCallbackForNewScrapRate} pinned='right'></AgGridColumn>}
                                                    <AgGridColumn width={columnWidths?.ScrapRate.existing} field={isImpactedMaster ? "OldScrapRate" : "ScrapRate"} editable='false' cellRenderer='oldScrapRateFormatter' headerName="Existing" colId={isImpactedMaster ? "OldScrapRate" : "ScrapRate"} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.ScrapRate.revised} cellRenderer={'newScrapRateFormatter'} field="NewScrapRate" headerName="Revised" colId="NewScrapRate" valueGetter={ageValueGetterScrapRate} headerComponent={'revisedScrapRateHeader'} editable={isImpactedMaster ? false : EditableCallbackForNewScrapRateSecond} onCellValueChanged='cellChange' pinned='right' valueSetter={(params) => {
                                                        // Use the validation-enabled value setter
                                                        return valueSetter(params, 'scrapRate');
                                                    }}></AgGridColumn>
                                                </AgGridColumn>
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.OtherCost.group} headerName={
                                                    "Other Cost (Currency)"

                                                } marryChildren={true} pinned='right' >
                                                    {/* <AgGridColumn minWidth={150} cellRenderer='existingOtherCostFormatter' field={isImpactedMaster ? "OtherNetCost" : 'isCostingSimulation' ? 'OldRawMaterialIndexationDetails.OtherNetCost' : "OtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OtherNetCost" : "OtherNetCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={'isCostingSimulation' ? 'NewRawMaterialIndexationDetails.OtherNetCost' : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' headerComponent={'revisedBasicRateHeader'}></AgGridColumn> */}
                                                    <AgGridColumn width={columnWidths?.OtherCost.existing} cellRenderer='existingOtherCostFormatter' field={"isImpactedMaster ? OldOtherCost : OtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OtherNetCost" : "OtherNetCost"} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.OtherCost.revised} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewOtherCost" : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && list[0]?.CostingTypeId === ZBCTypeId && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicPrice.group} headerName={
                                                    "Basic Price (Currency)"

                                                } marryChildren={true} pinned='right'>
                                                    {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && <AgGridColumn width={columnWidths?.BasicPrice.existing} field={isImpactedMaster ? 'OldNetCostWithoutConditionCost' : 'NetCostWithoutConditionCost'} cellRenderer={'zeroFormatter'} editable='false' headerName="Existing" colId='NetCostWithoutConditionCost' pinned='right'></AgGridColumn>}
                                                    {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && <AgGridColumn width={columnWidths?.BasicPrice.revised} field={isImpactedMaster ? "NewNetCostWithoutConditionCost" : "NewNetCostWithoutConditionCost"} cellRenderer={'basicPriceFormatter'} editable='false' headerName="Revised" colId='NewNetCostWithoutConditionCost' pinned='right'></AgGridColumn>}
                                                </AgGridColumn>}

                                                {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && list[0]?.CostingTypeId === ZBCTypeId && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ConditionCost.group} headerName={
                                                    "Condition Cost (Currency)"

                                                } marryChildren={true} pinned='right' >
                                                    {/* <AgGridColumn minWidth={150} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "NetConditionCost" : 'isCostingSimulation' ? 'OldRawMaterialIndexationDetails.NetConditionCost' : "NetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} ></AgGridColumn>
                                                    <AgGridColumn minWidth={150} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={'isCostingSimulation' ? 'NewRawMaterialIndexationDetails.NetConditionCost' : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' headerComponent={'revisedBasicRateHeader'}></AgGridColumn> */}
                                                    <AgGridColumn width={columnWidths?.ConditionCost.existing} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "OldNetConditionCost" : "NetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.ConditionCost.revised} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewNetConditionCost" : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' pinned='right'></AgGridColumn>
                                                </AgGridColumn>}

                                                {/* <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName={"BOP Net Landed Cost Conversion"} marryChildren={true}>
                                                <AgGridColumn minWidth={120} field="OldRMNetLandedCostConversion" editable='false' cellRenderer={'hyphenFormatter'} headerName="Existing" colId='OldRMNetLandedCostConversion' suppressSizeToFit={true}></AgGridColumn>
                                                <AgGridColumn minWidth={120} field="NewRMNetLandedCostConversion" editable='false' cellRenderer={'hyphenFormatter'} headerName="Revised" colId='NewRMNetLandedCostConversion' suppressSizeToFit={true}></AgGridColumn>
                                            </AgGridColumn> */}
                                                {getConfigurationKey()?.IsShowFreightAndShearingCostFields && <AgGridColumn minWidth={columnWidths?.RMFreightCost} field="RMFreightCost" tooltipField='RMFreightCost' editable='false' cellRenderer={'CostFormatter'} headerName="Freight Cost"></AgGridColumn>}
                                                {getConfigurationKey()?.IsShowFreightAndShearingCostFields && <AgGridColumn minWidth={columnWidths?.RMShearingCost} field="RMShearingCost" tooltipField='RMShearingCost' editable='false' cellRenderer={'CostFormatter'} headerName="Shearing Cost" ></AgGridColumn>}
                                                {technologyId === String(FORGING) && <AgGridColumn minWidth={columnWidths?.MachiningScrapRate} field="MachiningScrapRate" tooltipField='MachiningScrapRate' editable='false' headerName="Machining Scrap Rate" cellRenderer={'CostFormatter'}></AgGridColumn>}
                                                {<AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.NetCost.group} headerName={
                                                    "Net Cost (Currency)"

                                                } marryChildren={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.NetCost.existing} field="NetLandedCost" tooltipField='NetLandedCost' editable='false' cellRenderer={'costFormatter'} headerName="Existing" colId='NetLandedCost' pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.NetCost.revised} field="NewNetLandedCost" editable='false' valueGetter={ageValueGetterLanded} cellRenderer={'NewcostFormatter'} headerName="Revised" colId='NewNetLandedCost' pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                }
                                                {/* THIS COLUMN WILL BE VISIBLE IF WE ARE LOOKING IMPACTED MASTER DATA FOR RMIMPORT */}
                                                {(isImpactedMaster || props?.lastRevision || (String(props?.masterId) === String(EXCHNAGERATE) || String(props?.masterId) === String(RMIMPORT))) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.PlantCurrency.group} headerName={`Net Cost (Plant Currency)`} marryChildren={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.PlantCurrency.existing} field="OldNetLandedCostLocalConversion" tooltipField='OldRMNetLandedCostConversion' editable='false' headerName="Existing" colId='OldRMNetLandedCostConversion' cellRenderer='localConversionFormatter' pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.PlantCurrency.revised} field="NewNetLandedCostLocalConversion" editable='false' headerName="Revised" colId='NewRMNetLandedCostConversion' cellRenderer='localConversionFormatter' pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                }
                                                {props.children}
                                                <AgGridColumn minWidth={columnWidths?.EffectiveDate} field="EffectiveDate" editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "Current Effective date" : "Effective Date"} ></AgGridColumn>
                                                <AgGridColumn field="RawMaterialId" hide></AgGridColumn>

                                            </AgGridReact>))}

                                        {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        {
                            !isImpactedMaster &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                        <DatePicker
                                            name="EffectiveDate"
                                            id="EffectiveDate"
                                            selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                            onChange={handleEffectiveDateChange}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            dateFormat="dd/MM/yyyy"
                                            minDate={maxDate}
                                            placeholderText="Select effective date"
                                            className="withBorder"
                                            autoComplete={"off"}
                                            disabledKeyboardNavigation
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                        {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                    </div>
                                    <button onClick={verifySimulation} type="submit" id="verify-btn" className="user-btn mr5 save-btn verifySimulation" disabled={isDisable}>
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Verify"}
                                    </button>
                                </div>
                            </Row>
                        }
                    </Fragment>

                }
                {
                    openOtherCostDrawer &&
                    <AddOtherCostDrawer
                        isOpen={openOtherCostDrawer}
                        anchor={"right"}
                        closeDrawer={closeOtherCostDrawer}
                        rawMaterial={true}
                        rmBasicRate={
                            // FIX CT2-I238: Compute basicRate directly from rowData to avoid stale state after pagination
                            rowData?.NewBasicrateFromPercentage !== undefined && rowData?.NewBasicrateFromPercentage !== null
                                ? rowData?.NewBasicrateFromPercentage
                                : (rowData?.NewBasicRate && Number(rowData?.NewBasicRate) !== 0)
                                    ? rowData?.NewBasicRate
                                    : rowData?.BasicRatePerUOM || 0
                        }
                        ViewMode={isImpactedMaster || isViewFlag}
                        rmTableData={otherCostDetailForRow}
                        RowData={rowData}
                        plantCurrency={rowData?.Currency}
                        settlementCurrency={rowData?.Currency}
                        isImpactedMaster={isImpactedMaster}
                        disabled={isImpactedMaster}
                    />
                }
                {
                    getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && openConditionCostDrawer &&
                    <AddConditionCosting
                        isOpen={openConditionCostDrawer}
                        tableData={conditionCostDetailForRow}
                        closeDrawer={closeConditionCostDrawer}
                        anchor={'right'}
                        basicRateBase={netCostWithoutConditionCost}
                        ViewMode={isImpactedMaster || isViewFlag}
                        isFromMaster={true}
                        // isFromImport={states.isImport}
                        // EntryType={checkForNull(ENTRY_TYPE_DOMESTIC)}
                        currency={rowData?.Currency}
                        PlantCurrency={rowData?.Currency}
                        isImpactedMaster={isImpactedMaster}
                        disabled={isImpactedMaster}

                    />
                }
                {
                    showverifyPage &&
                    <VerifySimulation token={token} cancelVerifyPage={cancelVerifyPage} />
                }
                {
                    showPopup && <PopupMsgWrapper isOpen={showPopup} closePopUp={closePopUp} confirmPopup={onPopupConfirm} message={popupMessage} />
                }

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
            </div>
        </div>
    );
}


export default RMSimulation;
